export { ReactComponent as QuestionsCircles } from './svgs/questions-circles.svg';
